import getEnvVar from "../utils/getEnvVar";
import { ServiceConfig } from "../types/serviceConfig";

/**
 * Fetch environment variables with sensible defaults.
 */
const API_HOST_URL = getEnvVar(
	"REACT_APP_API_HOST_URL",
	"http://localhost:5001",
);
const API_PREFIX = getEnvVar("REACT_APP_API_PREFIX", "/api/v1");
const USE_MOCK_API = getEnvVar("REACT_APP_USE_MOCK_API", "1") === "1";

/**
 * Construct the service configuration object using the defined types.
 */
export const serviceConfig: ServiceConfig = {
	api: {
		hostUrl: API_HOST_URL,
		prefix: API_PREFIX,
		baseUrl: `${API_HOST_URL}${API_PREFIX}`,
		useMock: USE_MOCK_API,
	},
	routes: {
		content: getEnvVar("REACT_APP_API_CONTENT_ROUTE", "/content/"),
		contentType: getEnvVar("REACT_APP_API_GET_CONTENT_ROUTE", "/content_type/"),
		login: getEnvVar("REACT_APP_API_LOGIN_ROUTE", "/auth/login/"),
		logout: getEnvVar("REACT_APP_API_LOGOUT_ROUTE", "/auth/logout/"),
		register: getEnvVar("REACT_APP_API_REGISTER_ROUTE", "/auth/register/"),
		registerRequest: getEnvVar(
			"REACT_APP_API_REGISTER_REQUEST_ROUTE",
			"/auth/register-request/",
		),
		validateOtp: getEnvVar(
			"REACT_APP_API_VALIDATE_OTP_ROUTE",
			"/auth/validate-otp/",
		),
		refreshToken: getEnvVar(
			"REACT_APP_API_REFRESH_TOKEN_ROUTE",
			"/auth/refresh-token/",
		),

		company: getEnvVar("REACT_APP_API_COMPANY_ROUTE", "/company/"),
		analitics: getEnvVar("REACT_APP_API_COMPANY_ROUTE", "/analytics/"),
		news: getEnvVar("REACT_APP_API_NEWS_ROUTE", "/news/"),
		claims: getEnvVar("REACT_APP_API_CLAIMS_ROUTE", "/claim/"),
		offerById: getEnvVar("REACT_APP_API_OFFER_ROUTE", "/offer/"),
		offersDetailed: getEnvVar(
			"REACT_APP_API_OFFER_DETAILED_ROUTE",
			"/offer/detailed/",
		),
		log: getEnvVar("REACT_APP_API_LOG_ROUTE", "/analytics/action-log/"),
		adminUsers: getEnvVar(
			"REACT_APP_API_ADMIN_USERS_ROUTE",
			"/analytics/admin/users/",
		),

		uploadImage: getEnvVar(
			"REACT_APP_API_UPLOAD_IMAGE_ROUTE",
			"/media/upload/",
		),
		getImage: getEnvVar("REACT_APP_API_GET_IMAGE_ROUTE", "/uploads"),
	},
	headers: {
		contentType: getEnvVar(
			"REACT_APP_API_CONTENT_TYPE",
			"application/json; charset=utf-8",
		), // Add charset=utf-8
		accept: getEnvVar(
			"REACT_APP_API_ACCEPT",
			"application/json; charset=utf-8",
		), // Add charset=utf-8
	},
};

export default serviceConfig;
